<div [class.w-100]="btnClass">
	<label [ngClass]="btnClass || 'py-3'" style="cursor:pointer; display: inline-flex; align-items: center; justify-content: center;">
		<div *ngIf="!btnClass">
			<div [ngClass]="containerClasses">
				<img [ngClass]="imageClasses" [src]="rest.getImagePath(image,null)">
			</div>
		</div>
		<form #attachmentForm style="display:none">
			<input type="file" [name]="file_id" (change)="uploadAttachment($event, attachmentForm)" [multiple]="multiple" [accept]="accept">
		</form>
		<span *ngIf="displayUploadedAttachmentName" class="d-flex align-items-center justify-content-center">
			<svg *ngIf="btnClass" xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24" class="me-1"><path fill="currentColor" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6m2 16H8v-2h8v2m0-4H8v-2h8v2m-3-5V3.5L18.5 9H13z"/></svg>
			{{filename || default_message}}
		</span>
	</label>
</div>

